import Backbone from 'backbone';
import AdminConstants from 'constants/AdminConstants';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
var storeProto = {
    defaults: {
        transactions: [],
        type: false,
        id: false,
        loading: false
    },
};
var Actions = AdminConstants.ActionTypes;
// Action handlers
storeProto[Actions.STRIPE_PAYOUTS_FETCH] = function (payload) {
    this.set({ loading: true, transactions: [], id: payload.id, type: 'payouts' });
};
storeProto[Actions.STRIPE_CHARGES_FETCH] = function (payload) {
    this.set({ loading: true, transactions: [], id: payload.id, type: 'charges' });
};
storeProto[Actions.RECEIVE_STRIPE_PAYOUTS] = function (payload) {
    this.set({ loading: false, transactions: payload.data });
};
storeProto[Actions.RECEIVE_STRIPE_CHARGES] = function (payload) {
    this.set({ loading: false, transactions: payload.data });
};
// Create the store
var StripeStore = Backbone.Model.extend(storeProto), store = new StripeStore();
// Register it
AdminAppDispatcher.register(function (payload) {
    if (store[payload.action.type])
        store[payload.action.type](payload.action);
});
export default store;
